var $b100c352a523fa3c$exports = {};
$b100c352a523fa3c$exports = {
    "(optional)": `(valikuline)`,
    "(required)": `(n\xf5utav)`
};


export {$b100c352a523fa3c$exports as default};
//# sourceMappingURL=et-EE.mjs.map
